<head-meta [title]="this.title" />
<app-help-button src="/assets/help/versions/detail.md" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <ng-container *ngrxLet="version$ as version; error as e; complete as c">
                @if(version) {
                    <div class="navbar bg-base-100">
                        <div class="flex-none">
                          <a routerLink="/versions" routerLinkActive="active" class="btn btn-square btn-ghost text-primary"><fa-icon [icon]="faArrowLeft" class="w-5"></fa-icon></a>
                        </div>
                        <div class="flex-1">
                          <h1 class="h1 ml-4">{{version.name}}</h1>
                        </div>
                        <div class="flex-none">
                            @if(this.auth.has('version_update')) {
                                <button [routerLink]="'/versions/' + this.id + '/edit'" routerLinkActive="active" class="btn btn-ghost text-primary">
                                    <fa-icon [icon]="faPenToSquare" class="w-5"></fa-icon> Edit
                                </button>
                            }
                        </div>
                    </div>
                    <hr class="hr" />
                    <div class="overflow-hidden bg-white shadow sm:rounded-lg">
                        <div class="border-t border-gray-100">
                            <dl class="divide-y divide-gray-100">
                                @if (version.algorithm) {
                                    <div>
                                        <app-detail-display title="Algorithm" [value]="version.algorithm.name" />
                                    </div>
                                }
                                <div>
                                    <app-detail-display title="Latest Firmware" [value]="version.latest_firmware?.name ?? 'Not set'" />
                                </div>
                                <div>
                                    <app-detail-display title="Minimum Version" [value]="version.minimum_version.toString()" />
                                </div>
                                @if(this.auth.has('version_update')) {
                                    <div>
                                        <app-created-updated-display [entity]="version" />
                                    </div>
                                }
                            </dl>
                        </div>
                    </div>
                }
                <app-loading-error-block [error]="e?.error" [complete]="c" />
            </ng-container>
        </div>
    </div>
</article>